import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config';
import { Card, Button, Form, Container, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import './adminlogin.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(API_ENDPOINTS.adminLogin, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        setError(null);
        navigate('/dashboard');
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to login. Please try again.');
      }
    } catch (error) {
      console.error('Login failed', error);
      setError('Failed to login. Please check your network and try again.');
    }
  };

  return (
    <div className="login-page d-flex align-items-center justify-content-center">
      <Container fluid className="px-4">
        <Row className="justify-content-center">
          <Col md={5} lg={4} xl={4} className="mb-4 mb-md-0">
            <Card className="shadow-lg border-0 rounded-lg h-100">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center p-5">
                <img
                  src="/images/logo.png"
                  alt="Protect-Her Logo"
                  className="mb-4 img-fluid"
                  style={{ maxWidth: '150px' }}
                />
                <h2 className="text-center mb-2 fw-bold">Protect-Her</h2>
                <h3 className="text-center">Hello, Admin!</h3>
                <p className="text-center text-muted">Welcome back to your dashboard</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5} lg={4} xl={4}>
            <Card className="shadow-lg border-0 rounded-lg h-100">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4">Login</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-envelope"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="py-2"
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <InputGroup>
                      <InputGroup.Text>
                        <i className="bi bi-lock"></i>
                      </InputGroup.Text>
                      <Form.Control
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="py-2"
                      />
                    </InputGroup>
                  </Form.Group>
                  <div className="d-grid">
                    <Button variant="primary" type="submit" className="btn-lg">
                      Login
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;